import Divider from '@mui/material/Divider';

import StyledStackHeader from '@webclient/components/settings/components/form-header/styles';
import {
  StyledHeaderContainer,
  StyledHeaderIconBox,
} from '@webclient/components/settings/styles';

import { Text } from '@knowz/knowz-ui';

export default function FormHeader({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <StyledStackHeader>
      <StyledHeaderContainer>
        <Text
          variant="textLg"
          weight="semibold"
        >
          {title}
        </Text>

        <StyledHeaderIconBox>{children}</StyledHeaderIconBox>
      </StyledHeaderContainer>
      <Divider />
    </StyledStackHeader>
  );
}
